var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{staticClass:"layout-footer"},[_c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("京ICP备19040055号-1")])])])}
var staticRenderFns = []

export { render, staticRenderFns }